import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {dashboardGetSchoolsAuthor} from '../../../../Schools/actions';
import DashboardSchoolsListItem from "./DashboardSchoolsListItem";
import DashboardSchoolsListItemPlaceholder from "./DashboardSchoolsListItemPlaceholder";
import Button from "@material-ui/core/Button";
import LoadingSpinner from "../../../../Layout/components/LoadingSpinner";
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../../translations/translations_schools';

class DashboardSchoolsList extends Component {
    state = {
        initialLoad: true,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    fetchContent() {
        // Fetch the schools where the current logged in user is checked in
        this.props.dashboardGetSchoolsAuthor(
            1, // No offset
            true, // Reset the search results / listing
        );
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.languages !== this.props.languages) {
            this.fetchContent();
        }
    }

    loadMore = (e) => {
        e.preventDefault();

        const {dashboardSchoolsLoading, hasMore, currentPage} = this.props.schools;

        if (hasMore && !dashboardSchoolsLoading) {
            this.setState({initialLoad: false});

            this.props.dashboardGetSchoolsAuthor(currentPage + 1);
            // TODO search criteria
        }
    };

    render() {
        const {dashboardSchoolsAuthor, dashboardSchoolsLoading, hasMore} = this.props.schools;

        let placeholders = [];

        for (let i = 0; i < 8; i++) {
            placeholders.push(<DashboardSchoolsListItemPlaceholder key={i}/>);
        }

        let schools = [];
        if (!dashboardSchoolsLoading) {
            if (this.props.filter === 'author') {
                schools = dashboardSchoolsAuthor;
            }
        }

        return (
            <Fragment>
                <section id="schools-list-dashboard">
                    <div className="row">
                        {(dashboardSchoolsLoading && this.state.initialLoad) && placeholders}
                        {!dashboardSchoolsLoading && Array.isArray(schools) && schools.map(school => (
                            <DashboardSchoolsListItem key={school.id} school={school} />
                        ))}
                        {(!dashboardSchoolsLoading && (schools.length === 0 || !Array.isArray(schools))) &&
                            <div className="col col-12 text-center">
                                {this.props.filter === 'author' &&
                                    <p>{this.props.translate('dashboard_schools.no_found_author')}</p>
                                }
                            </div>
                        }
                        {(dashboardSchoolsLoading && !this.state.initialLoad) && placeholders}
                    </div>
                    {(hasMore && !dashboardSchoolsLoading) &&
                        <div className="row row-more">
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <Button variant="contained" color="primary" size="medium" onClick={this.loadMore} className="btn-more">
                                        <Translate id="dashboard_schools.button_load_more" />
                                    </Button>
                                </div>
                            </div>
                        </div>
                    }
                    {((schools === null || dashboardSchoolsLoading) && !this.state.initialLoad) &&
                        <div className="row row-loading">
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <LoadingSpinner/>
                                </div>
                            </div>
                        </div>
                    }
                </section>
            </Fragment>
        );
    }
}

DashboardSchoolsList.propTypes = {
    dashboardGetSchoolsAuthor: PropTypes.func.isRequired,
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
    schools: state.schools,
});

export default connect(mapStateToProps, {dashboardGetSchoolsAuthor})(withLocalize(DashboardSchoolsList));


// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Schools/List/DashboardSchoolsList.js